import { render, staticRenderFns } from "./groupBuyBatchManage.vue?vue&type=template&id=60a63899&scoped=true"
import script from "./groupBuyBatchManage.vue?vue&type=script&lang=js"
export * from "./groupBuyBatchManage.vue?vue&type=script&lang=js"
import style0 from "./groupBuyBatchManage.vue?vue&type=style&index=0&id=60a63899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a63899",
  null
  
)

export default component.exports